/**
 * Tipos de mensajes que se pueden enviar al Backend
*
* Una vez conectados en el canal abierto (Subscribe) estos son los tipos de subscripción que se pueden enviar para recibir datos
*/
export enum E_SocketOperation {
    SENSORANDSECTION = 'SensorAndSection',
    SENSORS = 'Sensors',
    SECTION_SUBSCRIBE = 'SectionSubscribe',
    PATIENT_DATA = 'PatientData',
    DISPLAY_SUBSCRIBE = 'Display',
    GROUPED_OBSERVATIONS = 'GroupedObservations',
    DEMO = 'Demo'
}
